import { FilterFormLabels, FilterFormValues } from './types';
import {
    DefaultOptionList,
    DefaultOptions,
    FilteredValues,
} from '$saga/types/search.types';
import { defaultFormLabels, defaultFormValues } from './constants';

/**
 * Format selected value ids to their corresponding label
 * @param currentValue
 * @param options
 * @param allLabel
 */
export const findCurrentSelectedFilterLabel = (
    currentValue: string,
    options: FilteredValues | DefaultOptions,
    allLabel?: string,
) => {
    if (currentValue === '') return '';

    // handle all value
    if (currentValue === 'all') {
        return allLabel ?? '';
    }

    return (
        options.find((currentOption) => currentOption.value === currentValue)
            ?.label ?? ''
    );
};

/**
 * Initialize form with selected values
 * @param values
 * @param defaultOptions
 * @param defaultDestinationOptions
 * @param defaultSportOptions
 */
export const initializeLabelValues = (
    values: FilterFormValues,
    defaultOptions: DefaultOptionList,
    defaultDestinationOptions: DefaultOptions,
    defaultSportOptions: DefaultOptions,
): FilterFormLabels => {
    const destinationLabels = values.destination.map((dest) =>
        findCurrentSelectedFilterLabel(
            dest,
            defaultDestinationOptions,
            'Toutes',
        ),
    );

    const sportLabels = values.theme.map((theme) =>
        findCurrentSelectedFilterLabel(theme, defaultSportOptions, 'Tous'),
    );

    // Secondary filters
    const levelsLabel = values.levels
        .map((val) =>
            findCurrentSelectedFilterLabel(val, defaultOptions.levels),
        )
        .join(', ');

    const tagsLabel = values.tags
        .map((val) => findCurrentSelectedFilterLabel(val, defaultOptions.tags))
        .join(', ');

    const typesLabel = values.types
        .map((val) => findCurrentSelectedFilterLabel(val, defaultOptions.types))
        .join(', ');

    return {
        destination: destinationLabels,
        theme: sportLabels,
        startDate: values.startDate,
        endDate: values.endDate,
        nbPax: values.nbPax,
        // secondary
        levels: levelsLabel,
        types: typesLabel,
        duration: `${String(values.durationMin ?? defaultOptions.durationMin)} -
            ${String(values.durationMax ?? defaultOptions.durationMax)}`,
        budget: `${String(
            values.budgetMin ?? defaultOptions.budgetMin,
        )} - ${String(values.budgetMax ?? defaultOptions.budgetMax)}`,
        tags: tagsLabel,
    };
};

/**
 * Reset form with initial default values
 */
export const resetLabels = () => defaultFormLabels;

/**
 * Reset form with initial default labels
 */
export const resetValues = () => defaultFormValues;
